export interface OrgUsage {
	apiUsage: number;
	hasApiKeys: boolean;
	apiFreeCallsLimit: number;
	freeTrialDays: number;
}

export enum OrgFeatures {
	API = "API",
	REMOVE_BG = "REMOVE_BG",
	TAILORED_GENERATION = "TAILORED_GENERATION",
	ECOMMERCE = "ECOMMERCE",
	FOUNDATION_MODELS = "FOUNDATION_MODELS",
	IFRAME_WHITE_LABEL = "IFRAME_WHITE_LABEL",
	CAMPAIGN = "CAMPAIGN",
	AUTOMOTIVE = "AUTOMOTIVE",
}

export interface OrgSubscription {
	plan_name: string;
	interval: string;
	status: string;
	products?: string[];
	platform_fee: string;
	usage_fee: string;
	cancels_on?: string;
	renews_on?: string;
	hide_fees?: string;
	discount?: string;
	discount_expiry_date?: string;
	start_date?: number | null;
	is_blocked: boolean;
	block_reason?: string;
	block_notes?: string;
	features?: OrgFeatures[];
	is_marketplace?: boolean;
	org_created_at?: string; // ISO date string of organization creation
	total_credit_grant?: string;
	remaining_credit_grant?: string;
}

export interface OrgSubscriptionPlan {
	name: string;
	displayName: string;
	selfService: boolean;
	priceIds?: string[];
	couponId?: string;
	termsAndConditionsLink?: string;
}
